module.exports = __webpack_public_path__ + "img/my_bg1.592b2c55.jpg";